import Suru from "../../../../suru/js/app";

Suru.iframeform();

$(window).on('load', function(){
	Suru.photoquotepanel(); 
	Suru.media();
	Suru.tabbedContent();
	if($("svg.ball-path").css("display") == "none"){return;}
	var mediamultiplayer = $(".media-multiplayer").first(),
		quotePanel = $(".photo-quote-panel").first(),
		quotePanelProfile = quotePanel.find('.profile'),
		bio = $('.bio').first(),
		iconDisc = $('.icon-disc-secondary'),
		lightBoxFirst = $('.media-lightbox').first(),
		panelType7 = $(".panel-type-07"),
		svgElement = $("svg.ball-path"),
		svgPath = svgElement.find('path.path'),
		svgPath2 = svgElement.find('path.dash'),
		ball = $('#ball'),
		firstBallPoint = $('.change-ball-point1'),
		secondBallPoint = $('.change-ball-point2'),
		thirdBallPoint = $('.change-ball-point3'),
		contactBanner = $('.contact-banner'),
		scrollArrows = $('.scroll-arrows'),
		mainContent = $(".main-content"),
		offset = mainContent.offset().top,
		startX = 45,
		startY = 0,
		pointOneX = startX,
		pointOneY = quotePanel.offset().top - offset + 15,
		pointTwoX = startX + 60,
		pointTwoY = pointOneY + 60,
		pointThreeX = quotePanel.width() + 45,
		pointThreeY = pointTwoY,
		pointFourX = pointThreeX + 85,
		pointFourY = pointTwoY + 85,
		pointFiveX = pointFourX,
		pointFiveY = firstBallPoint.offset().top - offset + firstBallPoint.height(),
		pointFiveYHalf = $('.icon-disc-secondary').first().offset().top-offset+30,
		pointSixX = mainContent.width()/2,
		pointSixY = panelType7.first().offset().top - offset + 100,
		pointSevenX = pointSixX,
		pointSevenY = panelType7.last().offset().top - offset + panelType7.last().height() + 60,
		pointEightX = startX,
		pointEightY = pointSevenY,
		pointNineX = pointEightX,
		pointNineY = secondBallPoint.offset().top - offset + secondBallPoint.height(),
		pointTenX = pointNineX,
		pointTenY = $("#fund-managers").offset().top - offset,
		pointElevenX = pointTenX,
		pointElevenY = thirdBallPoint.offset().top - offset + (thirdBallPoint.height()/2),
		pointTwelveX = pointSixX;
	
	if (contactBanner.length < 1) {
		contactBanner = $('.contact-iframe-form h2');	
	}
	
	var	pointTwelveY = contactBanner.offset().top - offset + (contactBanner.outerHeight()/2),
		d = "M "+ startX + " " + startY + " L "+ pointOneX +" "+ pointOneY + " L " + pointTwoX + " " + pointTwoY + " L " + pointThreeX + " " + pointThreeY + " L " + pointFourX + " " + pointFourY + " L " + pointFiveX + " " + pointFiveY + " L " + pointSixX + " " + pointSixY + " L " + pointSevenX + " " + pointSevenY + " L " + pointEightX + " " + pointEightY + " L " + pointNineX + " " + pointNineY + " L " + pointTenX + " " + pointTenY + " L " + pointElevenX + " " + pointElevenY + " L " + pointTwelveX + " " + pointTwelveY;
	svgElement.css("height", mainContent.height());
	svgPath[0].setAttribute('d', d);
	svgPath2[0].setAttribute('d', d);
	var z = 10;
	
	
	
	quotePanelProfile.each(function(){
		$(this).find('.profile-image').removeClass('blue');
		$(this).css('z-index', z);
		z = z-1;
	});
	panelType7.each(function(index){
		index % 2 == 0 ? $(this).addClass('opaque2-left') : $(this).addClass('opaque2-right');
		if(index+1 == panelType7.length){$('.opaque2-right-me').addClass('opaque2-right');}
	});
	$("#global-breadth-local-depth").closest(".row").addClass('opaque');
	$("#down-animation, #down-animation2, #down-animation3, #little-margin-bottom").addClass('opaque3');

	quotePanel.find('.photo-quote-panel-panel.expanded').hide();
	var scrollpoints = {"secondAnimation": 800, "thirdAnimation": quotePanel.offset().top, "fourthAnimation": lightBoxFirst.offset().top + 300, "fifthAnimation" : firstBallPoint.offset().top - 150, "sixthAnimation": firstBallPoint.offset().top + 400, "seventhAnimation": $('#applying-strategies').offset().top -200, "eighthAnimation": secondBallPoint.offset().top + 200, "ninthAnimation": bio.first().offset().top -300, "tenthAnimation": bio.first().offset().top + 200};
	var ball = document.getElementById("ball");
	
	function expandQuotePanel()
	{
		delay=0;
		quotePanelProfile.each(function(){
			if(!$(this).hasClass('profile-last'))
			{
				$(this).delay(delay).addClass('margin-right');
			}
			delay = delay + 230;
		});		
	}
	function openQuotePanel()
	{
		quotePanelProfile.first().find('.profile-image').addClass('blue pulsate');
		quotePanel.find('.photo-quote-panel-panel').first().slideDown(function(){
			$(this).addClass('expanded');
		});		
	}

	function iconDiscs()
	{
		var timeout = 300;
		iconDisc.each(function(index){
			var element = $(this);
			setTimeout(function(){element.find('.icon-disc-secondary-icon').addClass('pulsate2');}, timeout);
			timeout = timeout + 300;
		});		
	}
	function arrows()
	{
		scrollArrows.addClass('animate');
	}
	function leftRightIn()
	{
		var timeout = 200;
		$('.opaque2-left, .opaque2-right').each(function(index){
			var element = $(this);
			setTimeout(function(){element.addClass('translateIn')}, timeout);
			if (index % 2 != 0)
			{
				timeout = timeout + 200;
			}
		});	
	}

	var timelineinit = new TimelineLite();
		timelineinit.addLabel('firstAnimation')
		.to(ball, 4, {bezier:{type:"cubic", values:[{left:1010,top:0},{left:960,top:30},{left:890,top:0},{left:810,top:70},{left:760,top:40},{left:610,top:0},{left:560,top:70},{left:510,top:50},{left:410,top:0},{left:360,top:70},{left:310,top:55},{left:260,top:0},{left:210,top:70},{left:160,top:60},{left:160,top:0},{left:110,top:70},{left:45,top:0},{left:45,top:60},{left:45,top:680}], autoRotate:false}, ease:Power0.easeOut}, "firstAnimation").call(arrows)
		.to(svgPath, 1.6, {strokeDashoffset: 8300, ease:Linear.easeNone}, "firstAnimation+=2.4")
		.addPause()
		.addLabel('secondAnimation')
		.call(function(){scrollArrows.removeClass('animate');}, this, 'secondAnimation')
		.to(ball, 0.5, {top:pointOneY, ease:Linear.easeNone})
		.to(ball, 0.1, {top:pointTwoY, left:pointTwoX, ease:Linear.easeNone}, "secondAnimation+=0.5").call(expandQuotePanel, this, 'secondAnimation')
		.to(ball, 0.8, {left:pointThreeX, ease:Linear.easeNone}, "secondAnimation+=0.6")
		.to(ball, 0.1, {top:pointFourY, left:pointFourX, ease:Linear.easeNone}, "secondAnimation+=1.4").call(openQuotePanel, this, 'secondAnimation')
		.to(svgPath, 1.5, {strokeDashoffset: 9000-(pointFourY+800), ease:Linear.easeNone}, "secondAnimation")
		.addPause()
		.addLabel('thirdAnimation')
		.call(function(){$('.profile-image').first().trigger('click');}, this, 'thirdAnimation')
		.to(ball, 0.7, {top:pointFiveYHalf, ease:Linear.easeNone}, "thirdAnimation").call(iconDiscs, this, 'thirdAnimation')
		.to(svgPath, 0.7, {strokeDashoffset: 9000-(pointFiveYHalf+800), ease:Linear.easeNone}, "thirdAnimation")
		.addPause()
		.addLabel('fourthAnimation')
		.call(function(){$('.row.opaque').addClass('translateIn');}, this, 'fourthAnimation')
		.to(ball, 1, {top:pointFiveY, ease:Linear.easeNone}, "fourthAnimation")
		.to(svgPath, 1, {strokeDashoffset: 9000-(pointFiveY+800), ease:Linear.easeNone}, "fourthAnimation")
		.addPause()
		.addLabel('fifthAnimation')
		.to(ball, 0.7, {top:pointSixY,left:pointSixX, ease:Linear.easeNone}, "fifthAnimation")
		.to(svgPath, 0.7, {strokeDashoffset: 9000-(pointSixY+1000), ease:Linear.easeNone}, "fifthAnimation")
		.addPause()
		.addLabel('sixthAnimation')
		.call(leftRightIn, this, 'sixthAnimation')
		.to(ball, 1, {top:pointSevenY, ease:Linear.easeNone}, "sixthAnimation")
		.to(svgPath, 1, {strokeDashoffset: 9000-(pointSevenY + 1000), ease:Linear.easeNone}, "sixthAnimation")
		.addPause()
		.addLabel('seventhAnimation')
		.to(ball, 0.5, {top:pointEightY,left:pointEightX, ease:Linear.easeNone}, "seventhAnimation")
		.to(ball, 0.8, {top:pointNineY,left:pointNineX, ease:Linear.easeNone}, "seventhAnimation+=0.5")
		.to(svgPath, 0.5, {strokeDashoffset: 9000-(pointEightY+1450), ease:Linear.easeNone}, "seventhAnimation")
		.to(svgPath, 0.8, {strokeDashoffset: 9000-(pointNineY+1400), ease:Linear.easeNone}, "seventhAnimation+=0.5")
		.addPause()
		.addLabel('eighthAnimation')
		.call(function(){$(".opaque3").delay(400).addClass('translateDown');}, this, 'eighthAnimation')
		.to(ball, 1, {top:pointTenY, ease:Linear.easeNone}, 'eighthAnimation')
		.to(svgPath, 1, {strokeDashoffset: 9000-(pointTenY+1400), ease:Linear.easeNone}, 'eighthAnimation')
		.addPause()
		.addLabel('ninthAnimation')
		.to(ball, 0.8, {top:pointElevenY,left:pointElevenX, ease:Linear.easeNone}, 'ninthAnimation')
		.to(svgPath, 0.8, {strokeDashoffset: 9000-(pointElevenY+1400), ease:Linear.easeNone}, 'ninthAnimation')
		.addPause()
		.addLabel('tenthAnimation')
		.to(ball, 0.7, {top:pointTwelveY,left:pointTwelveX, ease:Linear.easeNone}, 'tenthAnimation')
		.to(svgPath, 0.7, {strokeDashoffset: 9000-(pointTwelveY+1600), ease:Linear.easeNone}, 'tenthAnimation')
		.to(ball, 0.8, {borderRadius:'0',width:'100%',height:contactBanner.outerHeight(), ease:Linear.easeNone}, 'tenthAnimation+=0.7')
		.call(function(){
			if ($('.contact-iframe-form .content').length > 0) {
				$('.contact-iframe-form .content').slideDown(800);
			}
			
		});
		
		
		$(window).scroll(function(){
			var currentScroll = $(this).scrollTop();
			$.each(scrollpoints,function(key,val){
				if (currentScroll >= val)
				{	
					var timelinevalue = timelineinit.getLabelTime(key);
					timelineinit.play(timelinevalue, false);
					delete scrollpoints[key];
				}
			});			
		});
});


